<template>
  <div :class="['col-lg-'+columnSize, 'summary-bar-item']">
    <h2 class="no-margins" v-html="title"></h2>
    <small v-html="description"></small>
    <div class="progress progress-mini" v-if="percentValue !== null">
      <div class="progress-bar progress-bar-success" :style="{'width': percentValue + '%'}"></div>
    </div>
  </div>
</template>

<style scoped>
.summary-bar-item:not(:last-child) {
  border-right: 1px solid #efefef;
}
</style>

<script>
export default {
  props: {
    title: [String, Number],
    description: [String, Number],
    percentValue: {
      type: Number,
      default: null
    },
    columnSize: {
      type: Number,
      default: 3
    }
  }
}
</script>